import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

// Publication name = everything before the first "·" in the press source.
const pubName = (source) => (source || "").split("\u00b7")[0].trim();

export default function FeaturedIn() {
  const [pubs, setPubs] = useState([]);

  useEffect(() => {
    api
      .get("/public/press")
      .then((r) => {
        const seen = [];
        (r.data.items || []).forEach((p) => {
          const n = pubName(p.source);
          if (n && !seen.includes(n)) seen.push(n);
        });
        setPubs(seen);
      })
      .catch(() => {});
  }, []);

  if (pubs.length === 0) return null;

  return (
    <section className="border-t border-white/5 py-14" data-testid="home-featured-in">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12 text-center">
        {/* Eyebrow with flanking gold hairlines */}
        <div className="flex items-center justify-center gap-4 mb-8">
          <span className="h-px w-10 sm:w-16" style={{ background: "linear-gradient(to right, transparent, var(--gold))" }} />
          <span className="text-[11px] uppercase tracking-[0.4em] text-white/45">
            As Featured In
          </span>
          <span className="h-px w-10 sm:w-16" style={{ background: "linear-gradient(to left, transparent, var(--gold))" }} />
        </div>

        {/* Publication names — serif wordmarks with diamond dividers */}
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-4 sm:gap-x-8">
          {pubs.map((name, i) => (
            <div key={name} className="flex items-center gap-x-5 sm:gap-x-8">
              {i > 0 && (
                <span
                  aria-hidden="true"
                  className="hidden sm:inline-block rotate-45 w-1.5 h-1.5 shrink-0"
                  style={{ background: "var(--gold)", opacity: 0.45 }}
                />
              )}
              <span
                data-testid="featured-in-item"
                className="featured-in-name font-serif text-xl sm:text-2xl tracking-tight text-white/55 whitespace-nowrap transition-colors duration-300 hover:text-white cursor-default"
              >
                {name}
              </span>
            </div>
          ))}
        </div>

        <Link
          to="/press"
          data-testid="featured-in-link"
          className="link-gold inline-block mt-9 text-[11px] uppercase tracking-[0.3em]"
        >
          See all press →
        </Link>
      </div>
    </section>
  );
}
